import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function PaperclipIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m14 7.336-6.018 5.693c-1.368 1.295-3.587 1.295-4.956 0a3.19 3.19 0 0 1 0-4.688l6.018-5.694a2.43 2.43 0 0 1 3.304 0 2.127 2.127 0 0 1 0 3.126l-5.782 5.47a1.216 1.216 0 0 1-1.652 0 1.063 1.063 0 0 1 0-1.563l5.074-4.8" /></svg>
  );
}

export default PaperclipIcon;
